import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CreditNote, CreditNoteCreate, CreditNoteFilter } from '../data/creditNote';

export function createCreditNoteService(client: AxiosInstance) {
  return createCrudService<CreditNote, CreditNoteCreate, CreditNoteFilter>(
    client,
    '/sales/CreditNote',
    'id',
  );
}

export type CreditNoteService = CrudService<CreditNote, CreditNoteCreate, CreditNoteFilter>;
